{
 "assisted-pull-up": {
  "assetId": "25291301",
  "file": "25291301-Assisted-Pull-up-(female)_Back",
  "gymvisualProductId": 5541,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "back-extension": {
  "assetId": "44551301",
  "file": "44551301-45-degrees-Back-Extension_Hips",
  "gymvisualProductId": 11527,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "back-squat": {
  "assetId": "35931301",
  "file": "35931301-Barbell-Squat-(female)_Thighs",
  "gymvisualProductId": 9871,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-external-shoulder-rotation": {
  "assetId": "09211301",
  "file": "09211301-Band-standing-external-shoulder-rotation_Back",
  "gymvisualProductId": 2396,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "banded-face-pull": {
  "assetId": "08961301",
  "file": "08961301-Band-face-pull_Shoulders",
  "gymvisualProductId": 2371,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-curl": {
  "assetId": "35921301",
  "file": "35921301-Barbell-Curl-(female)_Upper-Arms",
  "gymvisualProductId": 9870,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-hip-thrust": {
  "assetId": "22161301",
  "file": "22161301-Barbell-Hip-Thrust-(female)_Hips",
  "gymvisualProductId": 4286,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-row": {
  "assetId": "22421301",
  "file": "22421301-Barbell-Bent-Over-Row-(female)_Back",
  "gymvisualProductId": 4312,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-shrug": {
  "assetId": "24801301",
  "file": "24801301-Barbell-Shrug-(female)_Back",
  "gymvisualProductId": 5928,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "belt-squat": {
  "assetId": "29501301",
  "file": "29501301-Lever-Belt-Squat_Thighs",
  "gymvisualProductId": 6763,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "bench-press": {
  "assetId": "24401301",
  "file": "24401301-Barbell-Bench-Press-(female)_Chest",
  "gymvisualProductId": 5907,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "bulgarian-split-squat": {
  "assetId": "35331301",
  "file": "35331301-Bulgarian-Split-Squat_Thighs",
  "gymvisualProductId": 8120,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-close-grip-seated-row": {
  "assetId": "26611301",
  "file": "26611301-Cable-Seated-Row-with-V-bar_Back",
  "gymvisualProductId": 6668,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-crunch": {
  "assetId": "23691301",
  "file": "23691301-Cable-Kneeling-Crunch-(female)_Waist",
  "gymvisualProductId": 5246,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-curl": {
  "assetId": "01561301",
  "file": "01561301-Cable-Curl_Upper-Arms",
  "gymvisualProductId": 1649,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-lateral-raise": {
  "assetId": "30541301",
  "file": "30541301-Cable-Lateral-Raise-(female)_Shoulders",
  "gymvisualProductId": 8267,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-pull-through": {
  "assetId": "12061301",
  "file": "12061301-Cable-pull-through_hips",
  "gymvisualProductId": 2656,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-row": {
  "assetId": "22451301",
  "file": "22451301-Cable-Seated-Row-(female)_Back",
  "gymvisualProductId": 4315,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "calf-raise": {
  "assetId": "30181301",
  "file": "30181301-Standing-Calf-Raise-(female)_Calves-FIX",
  "gymvisualProductId": 8236,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "captain-s-chair-leg-raises": {
  "assetId": "46141301",
  "file": "46141301-Captains-Chair-Straight-Leg-Raise-(female)_Waist",
  "gymvisualProductId": 12325,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "chin-up": {
  "assetId": "23791301",
  "file": "23791301-Chin-Up-(female)_Back",
  "gymvisualProductId": 5338,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "close-grip-bench-press": {
  "assetId": "23911301",
  "file": "23911301-Barbell-Close-Grip-Bench-Press-(female)_Upper-Arms",
  "gymvisualProductId": 5350,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "crunch": {
  "assetId": "47271301",
  "file": "47271301-Crunch-(arms-on-chest)-(female)_Waist",
  "gymvisualProductId": 10908,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dead-bug": {
  "assetId": "30711301",
  "file": "30711301-Dead-Bug-(female)_Waist",
  "gymvisualProductId": 8284,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "deadlift": {
  "assetId": "22141301",
  "file": "22141301-Barbell-Deadlift-(female)_Hips",
  "gymvisualProductId": 4284,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-bench-press": {
  "assetId": "22541301",
  "file": "22541301-Dumbbell-Bench-Press-(female)_Chest",
  "gymvisualProductId": 4324,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-bulgarian-split-squat": {
  "assetId": "22901301",
  "file": "22901301-Dumbbell-Bulgarian-Split-Squat-(female)_Thighs",
  "gymvisualProductId": 4904,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-chest-press": {
  "assetId": "02891301",
  "file": "02891301-Dumbbell-Bench-Press_Chest",
  "gymvisualProductId": 1782,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-curl": {
  "assetId": "02941301",
  "file": "02941301-Dumbbell-Biceps-Curl_Upper-Arms",
  "gymvisualProductId": 1787,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-romanian-deadlift": {
  "assetId": "22221301",
  "file": "22221301-Dumbbell-Romanian-Deadlift-(female)_Hips",
  "gymvisualProductId": 4292,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-row": {
  "assetId": "24821301",
  "file": "24821301-Dumbbell-Bent-Over-Row-(female)_Back",
  "gymvisualProductId": 5930,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-shoulder-press": {
  "assetId": "04051301",
  "file": "04051301-Dumbbell-Seated-Shoulder-Press_Shoulders",
  "gymvisualProductId": 1906,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-shrug": {
  "assetId": "25961301",
  "file": "25961301-Dumbbell-Shrug-(female)_Back",
  "gymvisualProductId": 5991,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "face-pull": {
  "assetId": "56091301",
  "file": "56091301-Cable-Standing-Face-Pull_Shoulders",
  "gymvisualProductId": 14040,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "farmer-carry": {
  "assetId": "29171301",
  "file": "29171301-Dumbbell-Farmers-Carry_Thighs",
  "gymvisualProductId": 6731,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "front-squat": {
  "assetId": "25021301",
  "file": "25021301-Barbell-Front-Squat-(female)_Thighs",
  "gymvisualProductId": 5948,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "glute-bridge": {
  "assetId": "24711301",
  "file": "24711301-Glute-Bridge-Two-Legs-on-Floor_Hips",
  "gymvisualProductId": 5512,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "goblet-squat": {
  "assetId": "22811301",
  "file": "22811301-Dumbbell-Goblet-Squat-(female)_Thighs",
  "gymvisualProductId": 4782,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "hack-squat": {
  "assetId": "26381301",
  "file": "26381301-Barbell-Hack-Squat-(female)_Hips",
  "gymvisualProductId": 6026,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "hack-squat-machine": {
  "assetId": "07431301",
  "file": "07431301-Sled-Hack-Squat_Hips-FIX",
  "gymvisualProductId": 2226,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "hammer-curl": {
  "assetId": "22391301",
  "file": "22391301-Dumbbell-Hammer-Curl-(female)_Upper-Arms",
  "gymvisualProductId": 4309,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "hanging-leg-raise": {
  "assetId": "04721301",
  "file": "04721301-Hanging-Leg-Raise_Hips",
  "gymvisualProductId": 1971,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "hip-thrust-machine": {
  "assetId": "21461301",
  "file": "21461301-Lever-Hip-Thrust_Hips",
  "gymvisualProductId": 4198,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "incline-bench-press": {
  "assetId": "23881301",
  "file": "23881301-Barbell-Incline-Bench-Press-(female)_Chest",
  "gymvisualProductId": 5347,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "incline-dumbbell-press": {
  "assetId": "24411301",
  "file": "24411301-Dumbbell-Incline-Bench-Press-(female)_Chest",
  "gymvisualProductId": 5908,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "incline-machine-chest-press": {
  "assetId": "24551301",
  "file": "24551301-Lever-Incline-Chest-Press-(female)_Chest",
  "gymvisualProductId": 5921,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "isometric-biceps-hold": {
  "assetId": "101381301",
  "file": "101381301-Standing-Isometric-Biceps-Hold_Stretching",
  "gymvisualProductId": 23663,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "isometric-scapular-retraction-hold": {
  "assetId": "110571301",
  "file": "110571301-Cable-Seated-Scapular-Retraction_Back",
  "gymvisualProductId": 24155,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "lat-pulldown": {
  "assetId": "22471301",
  "file": "22471301-Cable-Bar-Lateral-Pulldown-(female)_Back",
  "gymvisualProductId": 4317,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "lat-pulldown-with-neutral-grip": {
  "assetId": "75831301",
  "file": "75831301-Cable-Neutral-Grip-Lat-Pulldown-(male)_Back",
  "gymvisualProductId": 18251,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "lateral-raise": {
  "assetId": "03341301",
  "file": "03341301-Dumbbell-Lateral-Raise_shoulder-AFIX",
  "gymvisualProductId": 1835,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "leg-curl": {
  "assetId": "22231301",
  "file": "22231301-Lever-Lying-Leg-Curl-(female)_Thighs",
  "gymvisualProductId": 4293,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "leg-extension": {
  "assetId": "22561301",
  "file": "22561301-Lever-Leg-Extension-(female)_Thighs",
  "gymvisualProductId": 4326,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "leg-press": {
  "assetId": "22241301",
  "file": "22241301-Sled-45-degrees-Leg-Press-(female)_Thighs",
  "gymvisualProductId": 4294,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "machine-chest-press": {
  "assetId": "24571301",
  "file": "24571301-Lever-Chest-Press-(female)_Chest",
  "gymvisualProductId": 5923,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "machine-lateral-raise": {
  "assetId": "05841301",
  "file": "05841301-Lever-Lateral-Raise_shoulder",
  "gymvisualProductId": 2081,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "machine-row": {
  "assetId": "22461301",
  "file": "22461301-Lever-Seated-Row-(female)_Back",
  "gymvisualProductId": 4316,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "machine-shoulder-press": {
  "assetId": "14541103",
  "file": "14541103-Lever-Seated-Shoulder-Press_Shoulders",
  "gymvisualProductId": 2927,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "overhead-press": {
  "assetId": "11621301",
  "file": "11621301-Barbell-Standing-Military-Press_Shoulders",
  "gymvisualProductId": 2617,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "overhead-triceps-extension": {
  "assetId": "46671301",
  "file": "46671301-Bodyweight-Overhead-Triceps-Extension-(female)_Upper-Arms",
  "gymvisualProductId": 13470,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "pause-squat": {
  "assetId": "50171301",
  "file": "50171301-Pause-Squat_Thighs",
  "gymvisualProductId": 25584,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "plank": {
  "assetId": "04651301",
  "file": "04651301-Front-Plank_Waist",
  "gymvisualProductId": 4402,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "pull-up": {
  "assetId": "06521301",
  "file": "06521301-Pull-up_Back",
  "gymvisualProductId": 2145,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "push-up": {
  "assetId": "28811301",
  "file": "28811301-Push-up_Pilates",
  "gymvisualProductId": 9830,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "reverse-dumbbell-flyes": {
  "assetId": "03831301",
  "file": "03831301-Dumbbell-Reverse-Fly_Shoulders",
  "gymvisualProductId": 1884,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "romanian-deadlift": {
  "assetId": "22131301",
  "file": "22131301-Barbell-Romanian-Deadlift-(female)_Hips-FIX",
  "gymvisualProductId": 4283,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "rowing-machine": {
  "assetId": "22621301",
  "file": "22621301-Rowing-(with-rowing-machine)-(female)_Cardio",
  "gymvisualProductId": 4769,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "seal-row": {
  "assetId": "87981301",
  "file": "87981301-Barbell-Lying-Seal-Row-on-Rack_Back",
  "gymvisualProductId": 21577,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "seated-calf-raise": {
  "assetId": "31061301",
  "file": "31061301-Lever-Seated-Calf-Raise-(plate-loaded)-(female)_Calves",
  "gymvisualProductId": 8319,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "seated-dumbbell-shoulder-press": {
  "assetId": "22371301",
  "file": "22371301-Dumbbell-Seated-Shoulder-Press-(female)_Shoulders",
  "gymvisualProductId": 4307,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "seated-leg-curl": {
  "assetId": "22571301",
  "file": "22571301-Lever-Seated-Leg-Curl-(female)_Thighs-FIX",
  "gymvisualProductId": 4327,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "side-plank": {
  "assetId": "07151301",
  "file": "07151301-Side-Plank-(male)_Waist-FIX",
  "gymvisualProductId": 4414,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "smith-machine-squat": {
  "assetId": "07701301",
  "file": "07701301-Smith-Squat_Hips",
  "gymvisualProductId": 2253,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "standing-calf-raise": {
  "assetId": "22111301",
  "file": "22111301-Lever-Standing-Calf-Raise-(female)_Calves",
  "gymvisualProductId": 4281,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "step-up": {
  "assetId": "08011301",
  "file": "08011301-Step-up_Hips",
  "gymvisualProductId": 2283,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "straight-arm-lat-pulldown": {
  "assetId": "02381301",
  "file": "02381301-Cable-Straight-Arm-Pulldown_Back-FIX",
  "gymvisualProductId": 1731,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "sumo-deadlift": {
  "assetId": "25171301",
  "file": "25171301-Barbell-Sumo-Deadlift-(female)_Hips",
  "gymvisualProductId": 5963,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "t-bar-row": {
  "assetId": "28851301",
  "file": "28851301-Lever-T-bar-Row-(plate-loaded)-(female)_Back",
  "gymvisualProductId": 8198,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "treadmill-run": {
  "assetId": "21971301",
  "file": "21971301-Run-on-Treadmill-(female)_Cardio",
  "gymvisualProductId": 4764,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "triceps-pushdown": {
  "assetId": "02411301",
  "file": "02411301-Cable-Triceps-Pushdown-(V-bar-attachment)_Upper-Arms",
  "gymvisualProductId": 1734,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "walking": {
  "assetId": "22611301",
  "file": "22611301-Walking-(female)_Cardio",
  "gymvisualProductId": 4768,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "walking-lunge": {
  "assetId": "38111301",
  "file": "38111301-Walking-Lunge-(female)_Thighs",
  "gymvisualProductId": 13425,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 }
}
